import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19bbe0a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-header flex-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left list-view-button" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-view-text" }, "List View", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "item-navigator-header-container" }
const _hoisted_7 = { class: "item-navigator-body-container" }
const _hoisted_8 = { class: "trailer-container" }
const _hoisted_9 = {
  key: 0,
  class: "reservation-expiry"
}
const _hoisted_10 = {
  key: 1,
  class: "timestamp-container"
}
const _hoisted_11 = { class: "trailer-type-text" }
const _hoisted_12 = {
  key: 2,
  class: "trailer-fault-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trailer-fault-text red-circle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "trailer-fault-title" }, "Cargo Sensor Issue"),
  /*#__PURE__*/_createTextVNode(" This may affect trailer availability ")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 3,
  class: "trailer-fault-container"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trailer-fault-text orange-circle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "trailer-fault-title" }, "Needs DOT Inspection"),
  /*#__PURE__*/_createTextVNode(" Requires inspection before trailer use ")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 3,
  class: "justify-content-center align-items-center button-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlreadyHaveTrailerAttached = _resolveComponent("AlreadyHaveTrailerAttached")!
  const _component_DriverLoaded = _resolveComponent("DriverLoaded")!
  const _component_AttachTrailerConfirmation = _resolveComponent("AttachTrailerConfirmation")!
  const _component_ItemNavigator = _resolveComponent("ItemNavigator")!
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", _ctx.isOverlayMinimized ? 'minimized-list' : ''])
  }, [
    (_ctx.alreadyAttached && !_ctx.detachModalHidden)
      ? (_openBlock(), _createBlock(_component_AlreadyHaveTrailerAttached, {
          key: 0,
          attachedTrailers: _ctx.currentAttachedTrailers,
          promptStillNearTrailer: true,
          onOnDetach: _ctx.confirmTrailerAttach,
          onOnSearchForTrailers: _ctx.hideAttachModal
        }, null, 8, ["attachedTrailers", "onOnDetach", "onOnSearchForTrailers"]))
      : _createCommentVNode("", true),
    (_ctx.showLoadedTrailerModal && _ctx.trailerAssociationsEnabled)
      ? (_openBlock(), _createBlock(_component_DriverLoaded, {
          key: 1,
          attachedTrailerNumber: _ctx.currentAttachedTrailers[0]?.trailerNumber,
          attachedTrailerCompany: 
                _ctx.currentAttachedTrailers[0]?.company ?? _ctx.driver.company
            ,
          showDeepLinkButton: true,
          onOnSearchForTrailers: _ctx.hideLoadedModal
        }, null, 8, ["attachedTrailerNumber", "attachedTrailerCompany", "onOnSearchForTrailers"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirm)
      ? (_openBlock(), _createBlock(_component_AttachTrailerConfirmation, {
          key: 2,
          trailerNumber: _ctx.trailerNumber,
          trailerCompany: _ctx.trailerCompany,
          onAccept: _ctx.attachTrailer,
          onReject: _ctx.cancelConfirm
        }, null, 8, ["trailerNumber", "trailerCompany", "onAccept", "onReject"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "flex-row",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToListView && _ctx.backToListView(...args)))
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.switchExpand && _ctx.switchExpand(...args)), ["stop"]))
        }, "Trailer Solutions")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ItemNavigator, {
          "current-index": _ctx.currentIndex,
          "total-items": _ctx.results.length,
          onCycleLeft: _ctx.cycleLeft,
          onCycleRight: _ctx.cycleRight
        }, null, 8, ["current-index", "total-items", "onCycleLeft", "onCycleRight"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_ItemNavigator, {
        "current-index": _ctx.currentIndex,
        "total-items": _ctx.results.length,
        onCycleLeft: _ctx.cycleLeft,
        onCycleRight: _ctx.cycleRight
      }, null, 8, ["current-index", "total-items", "onCycleLeft", "onCycleRight"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_CompanyLogo, {
        company: _ctx.trailerCompany,
        small: ""
      }, null, 8, ["company"]),
      _createElementVNode("div", {
        class: _normalizeClass(["trailer-title", { 'mark-green': _ctx.isReserved }])
      }, _toDisplayString(_ctx.trailerName), 3),
      (_ctx.isReserved)
        ? (_openBlock(), _createElementBlock("i", _hoisted_9, [
            _createTextVNode("Expires "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.reservationEndTime), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.timeZone), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasCargoSensor === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.lastUpdated) + " • ", 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.trailerTypeText), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasCargoSensorError === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
        : _createCommentVNode("", true),
      (_ctx.hasDotExpired === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
        : _createCommentVNode("", true)
    ]),
    (_ctx.trailerAssociationsEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_fbx_button, {
            "button-text": "Attach Trailer",
            theme: "primary",
            onClick: _withModifiers(_ctx.confirmTrailerAttach, ["prevent"])
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}